import { render, staticRenderFns } from "./QuickPanel.vue?vue&type=template&id=529fe981&scoped=true&"
import script from "./QuickPanel.vue?vue&type=script&lang=js&"
export * from "./QuickPanel.vue?vue&type=script&lang=js&"
import style0 from "./QuickPanel.vue?vue&type=style&index=0&id=529fe981&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "529fe981",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardTitle,VContainer})
